exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active,.fade-leave-active{transition:opacity .6s}.fade-enter,.fade-leave-to{opacity:0}", ""]);

// exports
